export enum UserRole {
  ADMIN = 'ADMIN',
  OPERATION = 'OPERATION',
  WAREHOUSE = 'WAREHOUSE',
  SALES = 'SALES',
  ACCOUNTANT = 'ACCOUNTANT',
  MANAGEMENT = 'MANAGEMENT',
}